export enum AnalyticsPages {
  DOCS = 'documentsRequests',
  DOC_DETAIL = 'documentsRequestDetail',
}

export const AnalyticsPlaces = {
  LIST: 'DocumentsRequestsList',
  DETAIL: 'DocumentsRequestDetail',
}
